export default __webpack_public_path__ + "static/media/verified.f940edce.svg";